import { Flex, Spinner } from "@chakra-ui/react";
import React from "react";

const Loading = () => {
  return (
    <Flex justifyContent="center" alignItems="center" h="100dvh">
      <Spinner alignSelf="center" />
    </Flex>
  );
};

export default React.memo(Loading);
